<template>
    <AppSelect
        ref="select"

        :model-value="modelValue"
        :selected-value="selectedValue"
        :selected-values="selectedValues"
        :placeholder="placeholder"
        :disabled="disabled"

        :option-key="optionKey"
        :option-value="optionValue"
        :option-title-formatter="optionTitleFormatter"
        :dropdown-width="dropdownWidth"
        :options="options"

        :has-search="true"
        :can-be-empty="canBeEmpty"
        :has-create-button="hasCreateButton"
        :is-autocomplete="true"

        @update:toggle="toggleShow"
        @update:search="debouncedSearch"
        @update:model-value="(option) => this.$emit('update:modelValue', option)"
        @click:create="$emit('click:create')"
        @reach-end="fetchOptions"
        @hide="hide"
    >
        <template #optionContent v-if="$slots.optionContent">
            <slot name="optionContent"></slot>
        </template>
        <template #optionItem="{option, index}">
            <slot name="optionItem" :option="option" :index="index"></slot>
        </template>
        <template #additionalLi>
            <li v-if="isFetching" class="select2-results__option" aria-disabled>Loading<span class="dots">.</span></li>
            <li v-if="notFoundMessage" class="select2-results__option select2-results__message">
                <Alert type="warning" :dismissible="false" margin-bottom="mb-0">
                    {{ notFoundMessage }}
                </Alert>
            </li>
        </template>
    </AppSelect>
</template>
<script>
import AppSelect from "../select/AppSelect.vue";
import { httpClient } from "../../../../services/HttpClient";
import { getMarketplaceNotFoundEntity } from "../../../../utils";
import Alert from "../../../AlertComponent.vue";
export default {
    name: "AppAutoComplete",
    components: {
        AppSelect, Alert
    },
    props: {
        modelValue: {
            type: [String, Number],
            default: ''
        },
        selectedValue: {
            type: [String, Number],
            default: ''
        },
        placeholder: {
            type: String,
            default: () => translate('components.select.default_placeholder')
        },
        url: {
            type: String,
            required: true
        },
        optionKey: {
            type: String,
            default: 'uuid'
        },
        optionValue: {
            type: String,
            default: 'name'
        },
        optionTitleFormatter: {
            type: Function,
            default: null
        },
        dropdownWidth: {
            type: String,
            default: null
        },
        canBeEmpty: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        hasCreateButton: {
            type: Boolean,
            default: false
        },
        queryParams: {
            type: Object,
            default: () => {return {}}
        },
        selectedValues: {
            type: Array,
            default: () => []
        },
        routeNeedCredential: {
            type: Boolean,
            default: false
        },
        limit: {
            type: Number,
            default: 10
        },
        notFoundAlertTexts: {
            type: Object,
            default: () => ({})
        }
    },
    emits: ['update:modelValue', 'clear', 'click:create'],
    data() {
        return {
            options: [],
            debounceTimer: null,
            page: 0,
            total: null,
            isFetching: false,
            search: '',
            notFoundMessage: null
        }
    },
    methods: {
        async toggleShow(newShow) {
            if (newShow) {
                await this.fetchOptions();
                this.$refs.select.show();
                return;
            }
            this.hide();
            this.$refs.select.hide();
        },
        async fetchOptions() {
            if (this.options.length === this.total || this.isFetching || this.notFoundMessage) return;

            this.page++;
            this.isFetching = true;

            let requestBody = {
                limit: this.limit,
                page: this.page,
                ...this.queryParams
            }

            if (this.search.length > 0) {
                requestBody.search = this.search;
            }

            try {
                const response = await httpClient.get(this.url, requestBody, this.routeNeedCredential);
                this.options.push(...response.data.data)
                this.total = response.data.meta.total
            } catch (error) {
                const entity = getMarketplaceNotFoundEntity(error);

                if (entity && this.notFoundAlertTexts?.[entity]) {
                    this.notFoundMessage = this.notFoundAlertTexts[entity];
                } else {
                    throw error;
                }
            } finally {
                this.isFetching = false;
            }
        },
        debouncedSearch(value) {
            clearTimeout(this.debounceTimer);
            this.debounceTimer = setTimeout(() => {
                this.search = value;
                this.options = [];
                this.total = null;
                this.page = 0;
                this.fetchOptions();
            }, 500);
        },
        hide() {
            this.options = [];
            this.isFetching = false;
            this.page = 0;
            this.total = null;
            this.search = '';
            this.notFoundMessage = null;
        }
    },
}
</script>
